/* stylelint-disable no-duplicate-selectors */
import { css } from '@emotion/css';

import { maxWidth, mobileMediaQuery } from '../../constants';
import { m, p2Css, p3Css } from '../../motif';

export const aiLocalizationBannerCss = css`
  align-items: center;
  background-color: ${m('--banner-ai-bg-color')};
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  width: 100%;

  ${mobileMediaQuery} {
    padding: ${m('--spacing-xl')};
  }
`;

export const aiLocalizationBannerContentCss = css`
  display: flex;
  flex-direction: column;
  flex: 1 0 0;
  gap: ${m('--spacing-xxs')};
  justify-content: center;
  margin: 0px auto;
  max-width: ${maxWidth}px;
  padding: ${m('--spacing-xl')} ${m('--spacing-xxxxl')};

  ${mobileMediaQuery} {
    padding: 0;
  }
`;

export const aiLocalizationBannerTitleCss = css`
  color: ${m('--banner-ai-fg-color')};
  ${p2Css}
`;

export const aiLocalizationBannerDescriptionCss = css`
  color: ${m('--banner-ai-fg-color')};
  ${p3Css}
`;
